module.exports = __webpack_public_path__ + "static/media/first-img.1005cad3.jpg";